import React, { Fragment, useEffect, useState } from 'react';
import SEO from '../../components/SEO/SEO';
import { useParams } from 'react-router-dom'
import { connect } from "react-redux";
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { addToCart } from "../../store/actions/action";
import Product from './product'
import api from "../../api";
import Footer from '../../components/footer/Footer';
import logo from '../../images/logo.svg';
import { useTranslation } from 'react-i18next';


const ProductSinglePage = (props) => {
    const { slug } = useParams()
    const { t } = useTranslation();


    const productsArray = api();
    const Allproduct = productsArray


    const { addToCart } = props;
    const [product, setProduct] = useState({});

    useEffect(() => {
        setProduct(Allproduct.filter(Allproduct => Allproduct.slug === String(slug)))
    }, [Allproduct, slug]);

    const item = product[0];

    return (
        <Fragment>
            <SEO title={item?.title || t('product.detailTitle', 'Ürün Detayı')} />
            <NavbarS2 hclass={'wpo-site-header wpo-site-header-s2'} Logo={logo} />
            <PageTitle pageTitle={t('product.detailTitle', 'Ürün Detayı')} pagesub={t('product.detailTitle', 'Ürün Detayı')} bgImage={'/banner/urunler.png'} />
            <section className="wpo-shop-single-section section-padding">
                <div className="container">
                    {item ? <Product
                        item={item}
                        addToCart={addToCart}
                    /> : null}
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

const mapStateToProps = state => {
    return {
        products: state.data.products,
    }
};

export default connect(mapStateToProps, { addToCart })(ProductSinglePage);
